import React, { Component} from 'react'
import { observer } from 'mobx-react'
import Store from '../store/ProductionTableStore'
import TableBody from '../partials/table/TableBody'
import TableHeader from '../partials/table/TableHeader'
import Popup from '../partials/popup'

@observer
class ArticleOrders extends Component {
    render() {  
        const data = Store.ordersByDate
        let header = null
        let orders = []        
        let days = Object.keys(data)
        let filterTitle = []

        if (Store.selectedFilters.length > 0) {
            Store.selectedFilters.forEach((filter) => {
                if (filter.label !== 'Välj alla') {
                    filterTitle.push(filter.label)
                }
            })
        }

        if (days.length > 0) {
            days.forEach((day, index) => {
                const currentDay = data[day]            

                if (index === 0) {
                    header = <TableHeader
                        searchTitle={ filterTitle.join(', ') }
                        day={ currentDay }
                    />                    
                }

                if (currentDay.orders.length > 0) {
                    currentDay.orders.forEach((order, key) => {
                        orders.push(<TableBody
                            key={ `table-body-${ day + key }` }
                            date={ day }
                            order={ order }
                            orderPosition={ key }
                        />)
                    })
                }
            })
        } else {
            header = <TableHeader
                searchTitle={ filterTitle.join(', ') }
                day={ null }
            />   

            orders.push(
                <div className="production-noOrdersFound" key={ 'currentOrders-0' }>
                    <h3 className="production-noOrdersFound__title">Inga ordrar hittades på denna filtrering.</h3>
                </div>
            )              
        }

        return <div>                        
            <div className="table">
                { header }
                { orders }

                <Popup
                    type="default"
                    show={ Store.popup.show }
                />
            </div>            
        </div>
    }
}

export default ArticleOrders
